export { default } from './enable-notifications-redirect'
